import { motion } from "framer-motion";
import { COURSE_SEATS } from "./kursusConstants";

export function UrgencyStrip() {
  return (
    <div data-testid="kursus-urgency-strip" className="kursus-light-sweep bg-kursus-red py-3 sm:py-4 border-y border-kursus-reddark">
      <motion.p
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.4 }}
        className="font-anton uppercase text-center text-kursus-white text-base sm:text-2xl tracking-wide px-4"
      >
        TERHAD {COURSE_SEATS} ORANG PESERTA SAHAJA
      </motion.p>
    </div>
  );
}
